import { useLocation, useNavigate } from "react-router-dom";

import {
  getExperimentsPath,
  getRootEv2ExperimentsPath,
} from "../Shared/shared.utils";
import { useEv2ExperimentParams } from "./UseCurrentExtension";

export function useNavigateEv2Experiments() {
  const navigate = useNavigate();
  const { search } = useLocation();

  const navigateToExperiment = (
    extension: string,
    experiment?: string,
    { isClone, isCreate }: { isClone?: boolean; isCreate?: boolean } = {},
  ) => {
    const path = getExperimentsPath(extension, experiment, {
      isClone,
      isCreate,
    });
    navigate(path + search);
    return path + search;
  };

  const navigateToExtensionDetails = (extension: string) => {
    const url = `/extensions/${extension}/extensionDetails` + search;
    navigate(url);
    return url;
  };

  const { extensionName = "" } = useEv2ExperimentParams();
  const navigateToRoot = () => {
    navigate(getRootEv2ExperimentsPath(extensionName) + search);
  };

  return { navigateToRoot, navigateToExperiment, navigateToExtensionDetails };
}
